var map = {
	"./arblogo.svg": 1323,
	"./arnavologo.svg": 1324,
	"./arrow_down.svg": 1325,
	"./arrow_up.svg": 1326,
	"./back.svg": 1327,
	"./baselogo.svg": 1328,
	"./blockwallet.svg": 1329,
	"./bobalogo.svg": 1330,
	"./book.svg": 1331,
	"./brave.svg": 1332,
	"./bsclogo.svg": 1333,
	"./close.svg": 1334,
	"./coinbase.svg": 1335,
	"./consensyslogo.svg": 1336,
	"./copy.svg": 1337,
	"./dailogo.svg": 1338,
	"./dydxlogo.svg": 1339,
	"./ethlogo.svg": 1340,
	"./gas_cost.svg": 1341,
	"./github.svg": 1342,
	"./help.svg": 1343,
	"./history_1.svg": 1344,
	"./history_2.svg": 1345,
	"./history_3.svg": 1346,
	"./history_4.svg": 1347,
	"./history_error.svg": 1348,
	"./history_fail.svg": 1349,
	"./history_success.svg": 1350,
	"./history_waiting.svg": 1351,
	"./home.svg": 1352,
	"./imxlogo.svg": 1353,
	"./loopringlogo.svg": 1354,
	"./maxInfo.svg": 1355,
	"./medium.svg": 1356,
	"./metamask.svg": 1357,
	"./metislogo.svg": 1358,
	"./more_horiz.svg": 1359,
	"./okxwallet.svg": 1360,
	"./oplogo.svg": 1361,
	"./orbiterAsZksyncLogo.svg": 1362,
	"./orbiterAsZksyncLogo_web.svg": 1363,
	"./orbiterLogo.svg": 1364,
	"./orbiterLogo_web--rinkeby.svg": 1365,
	"./orbiterLogo_web.svg": 1366,
	"./pglogo.svg": 1367,
	"./pglogo_bak.svg": 1368,
	"./realTransfer.svg": 1369,
	"./receive.svg": 1370,
	"./router.svg": 1371,
	"./scrolllogo.svg": 1372,
	"./search.svg": 1373,
	"./security.svg": 1374,
	"./send.svg": 1375,
	"./sknlogo.svg": 1376,
	"./success.svg": 1377,
	"./tallyho.svg": 1378,
	"./time_spent.svg": 1379,
	"./tips-default.svg": 1380,
	"./tips.svg": 1381,
	"./tokenLogo.svg": 1382,
	"./tooltip.svg": 1383,
	"./trading_fee.svg": 1384,
	"./transfer_mid.svg": 1385,
	"./twitter.svg": 1386,
	"./walletConnect.svg": 1387,
	"./withholding_gas_cost.svg": 1388,
	"./zk2logo.svg": 1389,
	"./zklogo.svg": 1390,
	"./zkspacelogo.svg": 1391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1322;